import {useContext} from 'react';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {MixpanelEventType, MixpanelSSOLaunchEvent, SSOApplication, SSOLaunchMethod} from "@/api/dto/mixpanel";
import {log} from "@/helpers/logger";
import {useMixpanel} from "@/hooks/useMixpanel";

export function useFindHelp() {
  const { carecoApi } = useContext(CarecoApiContext);
  const {mixpanelEventProperties} = useMixpanel();

  const openFindHelp =
    async (rosterId: number, patientId: string, goDirectly?: boolean, launchMethod = SSOLaunchMethod.CREATE_BUTTON) => {
      const newTab = window.open();
      if (!newTab) {
        return;
      }

      newTab.document.write('Loading...');

      try {
        const url = goDirectly ?
          process.env.REACT_APP_CARECO_API_FIND_HELP_URL : await carecoApi?.getFindHelpUrl(rosterId, patientId);
        if (url) {
          newTab.location.href = url;

          const event : MixpanelSSOLaunchEvent = {
            eventName: MixpanelEventType.BIH_SSO_LAUNCHED,
            ...mixpanelEventProperties!,
            applicationName: SSOApplication.FINDHELP,
            launchMethod
          };
          carecoApi?.postMixpanelEvent(event);
        }
      } catch (error) {
        log('error', 'Error fetching FindHelp SSO Redirect:', error);
        newTab.document.open();
        newTab.document.write('Error loading content.');
        newTab.document.close();
      }
    };

  return {
    openFindHelp,
  };
}
